import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardMedia,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import TabLayout from "../../helpers/TabLayout";
import {
  getSessionImageEndPoint,
  sessionUploadImage,
} from "../../../api/session";
import useInfoSnackbar from "../../../hooks/useInfoSnackbar";
import { CloudUploadOutlined } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { getSession, setSession } from "../../../bandung";
import useImageUpload from "../../../hooks/useImageUpload";

const ImageTab = () => {
  const {
    selectedImage,
    previewImageUrl,
    uploadPercentage,
    handleUploadProgress,
    setNewImage,
    reset,
  } = useImageUpload();
  const infoSnackbar = useInfoSnackbar();

  const handleImageChange = (event) => {
    if (event.target.files.length) {
      const file = event.target.files[0];
      setNewImage(file);
    }
  };

  const handleImageSaved = async (event) => {
    event.preventDefault();
    if (selectedImage !== null) {
      const response = await sessionUploadImage(
        selectedImage,
        getSession().userEntityId,
        handleUploadProgress,
      );
      if (response.code === "SUCCESS") {
        setSession({ ...getSession(), version: Date.now() });
        infoSnackbar.alertSuccess(response.message);
        window.location.reload();
      } else {
        infoSnackbar.alertError("Something went wrong...");
      }
    }
    reset();
  };

  return (
    <TabLayout
      headerLabel="Profile Image"
      skeletonLines={15}
    >
      <Stack
        component="form"
        width="100%"
        height="100%"
        justifyContent="space-evenly"
        alignItems="center"
        onSubmit={handleImageSaved}
        spacing={1}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "10px",
            border: "black 1px solid",
            minHeight: "clamp(250px, 280px, 320px)",
            width: "clamp(250px, 280px, 320px)",
            backgroundColor: grey[300],
          }}>
          {previewImageUrl && <CardHeader title={
            <Stack alignItems="center">
              <Typography
                variant="overline"
                fontWeight="bold">
                **Preview**
              </Typography>
            </Stack>}/>}
          <CardMedia
            component="img"
            image={previewImageUrl ??
              getSessionImageEndPoint(getSession()?.userEntityId)}
            sx={{ borderRadius: 5 }}
            alt="Profile Image"
          />
        </Card>
        {previewImageUrl ? (
          <>
            <Stack
              direction="row"
              spacing={2}
            >
              <Button
                variant="contained"
                onClick={() => reset()}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                onClick={handleImageSaved}
              >
                Save
              </Button>
            </Stack>
            {uploadPercentage > 0 && uploadPercentage < 100 &&
              <CircularProgress
                variant="determinate"
                value={uploadPercentage}
              />}
            {uploadPercentage === 100 &&
              <CircularProgress/>}
          </>
        ) : (
          <Button
            variant="contained"
            component="label"
            startIcon={<CloudUploadOutlined/>}
          >
            Upload New Image
            <input
              type="file"
              name="profileImage"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
          </Button>
        )}
      </Stack>
    </TabLayout>
  );
};

export default ImageTab;